import {
  Card,
  Checkbox,
  Divider,
  InlineStack,
  Tag,
  Text,
} from "@shopify/polaris";

const ProductOptions = ({
  productOptions,
  setProductOptions,
  selectedProductOptions,
  handleOptionValueRemove,
  handleOptionChange,
  disabled,
}) => {
  return (
    <>
      <Card>
        {productOptions.map((option) => {
          return (
            <>
              <Text variant="bodyLg">{option.productName}</Text>

              <br />
              {option.options.map((productOption) => {
                const isProductOptionsSelected =
                  selectedProductOptions[option?.productId];
                let isOptionSelected = false;

                if (isProductOptionsSelected) {
                  isOptionSelected = isProductOptionsSelected.options.some(
                    (selectedOption) =>
                      selectedOption.name === productOption.name
                  );
                }
                // const optionValues = isProductOptionsSelected

                return (
                  <>
                    <InlineStack align="start" blockAlign="center">
                      <Checkbox
                        disabled={disabled}
                        checked={isOptionSelected}
                        onChange={() => {
                          handleOptionChange({
                            productId: option?.productId,
                            option: productOption,
                          });
                        }}
                      />
                      <Text> {productOption.name}</Text>
                    </InlineStack>

                    <>
                      <InlineStack gap={"500"}>
                        {productOption.values.map((value, i) => {
                          const isValueSelected = selectedProductOptions[
                            option.productId
                          ]?.options
                            ?.find((o) => {
                              return o.name === productOption.name;
                            })
                            ?.values.includes(value);

                          return (
                            <div
                              style={{
                                color: "white",
                                backgroundColor: isValueSelected
                                  ? "black"
                                  : "gray",
                                borderRadius: "5px",
                                padding: "2px 4px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (isProductOptionsSelected) {
                                  handleOptionValueRemove({
                                    product: option?.productId,
                                    optionName: productOption?.name,
                                    optionValue: value,
                                  });
                                }
                              }}
                            >
                              {value}
                            </div>
                          );
                        })}
                      </InlineStack>
                      <br />
                    </>
                  </>
                );
              })}
              <Divider />
              <br />
            </>
          );
        })}
      </Card>
    </>
  );
};

export default ProductOptions;
